module.exports = __webpack_public_path__ + "geomanist-regular-webfont.0f2de97bae47a1d1f00a.svg";


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/assets/fonts/geomanist/geomanist-regular-webfont.svg
// module id = ../../../../../src/assets/fonts/geomanist/geomanist-regular-webfont.svg
// module chunks = main